import React, {Component} from 'react'
import {connect} from 'react-redux'
import Subjects from './Subjects'
import Categories from './Categories'
import Sources from './Sources'
import Trashed from './Trashed'
import Temp from './Temp'
import {setQbmNavItem, qbmNavItemSelector, QBM_NAV_SUBJECTS, QBM_NAV_CATEGORIES, QBM_NAV_SOURCES, QBM_NAV_TRASHED, QBM_NAV_TEMP} from '../../modules/app'


class QbmNav extends Component {
    render() {
        const {openItemId} = this.props
        return (
            <div className="qbm-accordion-panel">
                <Subjects openItemId = {openItemId} toggleCategories = {this.toggleCategories} toggleSubjects = {this.toggleSubjects} />
                <Categories openItemId = {openItemId} onClick = {this.toggleCategories} />
                <Sources openItemId = {openItemId} onClick = {this.toggleSources} />
                <Trashed openItemId = {openItemId} onClick = {this.toggleTrashed} />
                <Temp openItemId = {openItemId} onClick = {this.toggleTemp} />
            </div>
        )
    }

    toggleSubjects = () => this.props.setQbmNavItem(QBM_NAV_SUBJECTS)
    toggleCategories = () => this.props.setQbmNavItem(QBM_NAV_CATEGORIES)
    toggleSources = () => this.props.setQbmNavItem(QBM_NAV_SOURCES)
    toggleTrashed = () => this.props.setQbmNavItem(QBM_NAV_TRASHED)
    toggleTemp = () => this.props.setQbmNavItem(QBM_NAV_TEMP)
}

export default connect(
    state => ({
        openItemId : qbmNavItemSelector(state)
    }),
    { setQbmNavItem }
)(QbmNav)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmNav.js